// Application listesi
export const GET_APPLICATIONS_SERVICE_REQUEST = "GET_APPLICATIONS_SERVICE_REQUEST";
export const GET_APPLICATIONS_SERVICE_SUCCESS = "GET_APPLICATIONS_SERVICE_SUCCESS";
export const GET_APPLICATIONS_SERVICE_FAILURE = "GET_APPLICATIONS_SERVICE_FAILURE";

// Tek bir application getirme
export const GET_APPLICATION_BY_ID_SERVICE_REQUEST = "GET_APPLICATION_BY_ID_SERVICE_REQUEST";
export const GET_APPLICATION_BY_ID_SERVICE_SUCCESS = "GET_APPLICATION_BY_ID_SERVICE_SUCCESS";
export const GET_APPLICATION_BY_ID_SERVICE_FAILURE = "GET_APPLICATION_BY_ID_SERVICE_FAILURE";

// Application durumu güncelleme
export const UPDATE_APPLICATION_STATUS_SERVICE_REQUEST = "UPDATE_APPLICATION_STATUS_SERVICE_REQUEST";
export const UPDATE_APPLICATION_STATUS_SERVICE_SUCCESS = "UPDATE_APPLICATION_STATUS_SERVICE_SUCCESS";
export const UPDATE_APPLICATION_STATUS_SERVICE_FAILURE = "UPDATE_APPLICATION_STATUS_SERVICE_FAILURE";


// Application silme
export const DELETE_APPLICATION_SERVICE_REQUEST = "DELETE_APPLICATION_SERVICE_REQUEST";
export const DELETE_APPLICATION_SERVICE_SUCCESS = "DELETE_APPLICATION_SERVICE_SUCCESS";
export const DELETE_APPLICATION_SERVICE_FAILURE = "DELETE_APPLICATION_SERVICE_FAILURE";

// Application oluşturma
export const CREATE_APPLICATION_SERVICE_REQUEST = "CREATE_APPLICATION_SERVICE_REQUEST";
export const CREATE_APPLICATION_SERVICE_SUCCESS = "CREATE_APPLICATION_SERVICE_SUCCESS";
export const CREATE_APPLICATION_SERVICE_FAILURE = "CREATE_APPLICATION_SERVICE_FAILURE";

// Action Creators
export const getApplicationsServiceRequest = (params) => ({
  type: GET_APPLICATIONS_SERVICE_REQUEST,
  payload: params,
});

export const getApplicationByIdServiceRequest = (id) => ({
  type: GET_APPLICATION_BY_ID_SERVICE_REQUEST,
  payload: id,
});

export const updateApplicationStatusServiceRequest = (id, status) => ({
  type: UPDATE_APPLICATION_STATUS_SERVICE_REQUEST,
  payload: { id, status },
});

export const deleteApplicationServiceRequest = (id) => ({
  type: DELETE_APPLICATION_SERVICE_REQUEST,
  payload: id,
});

export const createApplicationServiceRequest = (data) => ({
  type: CREATE_APPLICATION_SERVICE_REQUEST,
  payload: data,
});